module.exports = __webpack_public_path__ + "img/aerospace-badge.1eaea555.png";